import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import { styled } from '@mui/material/styles'

export const ValidationErrorContainer = styled('div')`
  display: flex;
  align-items: center;
  margin-top: 10px;
`

export const ErrorIcon = styled(ErrorOutlineIcon)`
  margin-right: 8px;
`
